/**
 * Formats a 1–5 score (CSAT and similar) at the one-decimal display precision
 * used across the analytics module.
 */
export const formatScore = (value: number): string => value.toFixed(1);
